/**
 * package: com.inq.events
 * class: KeyboardEvent
 * @extends com.inq.events.Event 
 * @constructor
 */
com.inq.events.KeyboardEvent = function(type,bubbles,cancelable,charCode,keyCode,keyLocation,ctrlKey,altKey,shiftKey) {
	com.inq.events.Event.call(this,type);
};
$hxClasses['com.inq.events.KeyboardEvent'] = com.inq.events.KeyboardEvent;
/** @private @type {Array} */
com.inq.events.KeyboardEvent.__name__ = ["com","inq","events","KeyboardEvent"];
/** @private @type {Function} */
com.inq.events.KeyboardEvent.__super__ = com.inq.events.Event;
for(var k in com.inq.events.Event.prototype ) com.inq.events.KeyboardEvent.prototype[k] = com.inq.events.Event.prototype[k];
/** @private @type {boolean} */
com.inq.events.KeyboardEvent.prototype.m_shiftKey = null;
/** @private @type {number} */
com.inq.events.KeyboardEvent.prototype.m_keyLocation = null;
/** @private @type {number} */
com.inq.events.KeyboardEvent.prototype.m_keyCode = null;
/** @private @type {boolean} */
com.inq.events.KeyboardEvent.prototype.m_ctrlKey = null;
/** @private @type {number} */
com.inq.events.KeyboardEvent.prototype.m_charCode = null;
/** @private @type {boolean} */
com.inq.events.KeyboardEvent.prototype.m_altKey = null;

/**
 * updateAfterEvent
 *
 * $type TFun([],TEnum(Void,[]))
 * @private
 * @this com.inq.events.KeyboardEvent
 * @return {void}
 */
com.inq.events.KeyboardEvent.prototype.updateAfterEvent = function() {
};

/** @type {boolean} */
com.inq.events.KeyboardEvent.prototype.shiftKey = null;
/** @type {number} */
com.inq.events.KeyboardEvent.prototype.keyLocation = null;
/** @type {number} */
com.inq.events.KeyboardEvent.prototype.keyCode = null;
/** @type {boolean} */
com.inq.events.KeyboardEvent.prototype.ctrlKey = null;
/** @type {number} */
com.inq.events.KeyboardEvent.prototype.charCode = null;
/** @type {boolean} */
com.inq.events.KeyboardEvent.prototype.altKey = null;
/** @type {com.inq.events.KeyboardEvent} */
com.inq.events.KeyboardEvent.prototype.__class__ = com.inq.events.KeyboardEvent;
/** @type {string} */
com.inq.events.KeyboardEvent.KEY_DOWN = "KeyDown";

/** @type {string} */
com.inq.events.KeyboardEvent.KEY_UP = "KeyUp";

/** @type {string} */
com.inq.events.KeyboardEvent.KEY_PRESS = "KeyPress";

